import React, { useState } from "react";
import { FiAlignRight, FiBriefcase, FiGift, FiMail, FiMap, FiMoreVertical, FiPhone, FiX } from "react-icons/fi";
import ProfileFeedPage from '../../pages/profiles/feed';


export const UserDrawer = ({})=>{
    const [status, setStatus] = useState(true)
    const close = () => setStatus(false);
    const closeModal = (e) => {
        e.preventDefault()
        //close(false);
      } 

    return status ? (  
        <React.Fragment>
            <title>User Drawer</title>
            <div className="user-drawer">
                <div className="user-heading">
                    <div></div>
                    <div>
                        <a href="##">
                            <FiMoreVertical />
                        </a>
                        <a onClick={(e)=>closeModal(e)}>
                            <FiX />
                        </a>
                    </div>
                </div>
                <div>
                    <img src="/assets/images/faces/1.png" className="avatar"/>
                    <div>
                        <h4>Ahmet Mehmet Er</h4>
                        <p>Software Developer</p>
                    </div>
                </div>

                <ul>
                    <li>
                        <div className="icon">
                            <FiBriefcase />
                        </div>
                        <div className="desc">Apriorit Inc.</div>
                    </li>
                    <li>
                        <div className="icon">
                            <FiMail />
                        </div>
                        <div className="desc">ahmetmehmet@gmail.com</div>
                    </li>
                    <li>
                        <div className="icon">
                            <FiPhone />
                        </div>
                        <div className="desc">
                            Kniazia Volodymyra Velykoho Street, 34б, Dnipro, Dnipropetrovsk Oblast, Ukraine, 49000
                        </div>
                    </li>
                    <li>
                        <div className="icon">
                            <FiMap />
                        </div>
                        <ul className="desc">
                            <li>+90(512) 345 67 89 <span>• <b>Personal</b></span></li>
                            <li>+90(505) 987 65 43 <span>• <b>Business</b></span></li>
                            <li>0212 987 65 43 <span>• <b>Home</b></span></li>
                        </ul>
                    </li>
                    <li>
                        <div className="icon">
                            <FiGift />
                        </div>
                        <div className="desc">
                            17 Jun 1985
                        </div>
                    </li>
                    <li>
                        <div className="icon">
                            <FiAlignRight />
                        </div>
                        <div className="desc">
                                Aspernatur atque consequatur cum delectus deleniti dolorem doloremque earum error
                                fuga, fugit magni perspiciatis quisquam ut vitae voluptas. Aspernatur deserunt
                                excepturi explicabo fugiat nostrum nulla quasi reiciendis repellat repellendus,
                                unde? Animi architecto at blanditiis, commodi consectetur deleniti esse expedita facere,
                                fugit in ipsa magnam neque porro quisquam rerum similique suscipit temporibus ut
                                veniam voluptate? Dolorum esse inventore iure nostrum quos.
                        </div>
                    </li>
                </ul>
            </div>
            <div 
            className="overlay"  
            onClick={(e)=>closeModal(e)}
        >
       </div>

      <div className="overflow-hidden hidden">
        <ProfileFeedPage />
      </div>
   </React.Fragment>
    ) : <React.Fragment></React.Fragment>
}



export default UserDrawer